export const COLUIMN_MIN_WIDTH = {
	company: 240,
	phone: 180,
	manager: 200,
	status: 140,
	salesTarget: 140,
};
